import React from 'react'
import { Provider } from 'react-redux'
import { history, persistor, store } from '@store'
import { ConnectedRouter } from 'connected-react-router'
import { Route, Switch } from 'react-router-dom'
import LoginView from '@views/loginView'
import PasswordRecoveryRequestView from '@views/passwordRecovery/PasswordRecoveryRequestView'
import PasswordRecoveryCompleteView from '@views/passwordRecovery/PasswordRecoveryCompleteView'
import HomeView from '@views/home'
import { createMuiTheme, ThemeProvider } from '@material-ui/core'
import { green, orange, red } from '@material-ui/core/colors'
import PrivateRoute from '@views/shared/PrivateRoute'
import { SnackbarProvider } from 'notistack'
import Layout from '@views/shared/Layout'
import SignupView from '@views/signupView'
import ClubView from '@views/club'
import TrackingView from '@views/tracking'
import FilterTrack from '@views/FilterTrack'
import ProfileView from '@views/profile'
import { esES } from '@material-ui/core/locale'
import ReferralsView from '@views/referrals'
import Resources from '@views/resources'
import { PersistGate } from 'redux-persist/integration/react'
import Configurations from '@views/configurations'
import CommissionsView from '@views/commissions'
import ManageView from '@views/manage'
import ExecutiveCasesView from '@views/executiveCases'
import CommissionsReferrals from '@views/commissionsReferrals'
import PrepaymentsView from '@views/prepayments'
import AnalystTrackView from '@views/analystTrack'
import AnalystCasesView from '@views/analystCases'
import AnalystRejectedView from '@views/analystRejected'
import TimeTrackerView from '@officeTimeTracker/views/TimeTrackerView'
import AdminMetricsView from '@views/adminMetrics'
import ExecutiveCommissionsView from '@views/executiveCommissions'
import AgentCommissionsView from '@views/agentCommissions'
import ExecutiveMetricsView from '@views/executiveMetrics'
import { EXECUTIVE_METRICS_BLOCKED_ROLES } from '@views/executiveMetrics/utils'
import AgentMetricsView from '@views/agentMetrics'
import { AGENT_METRICS_BLOCKED_ROLES } from '@views/agentMetrics/utils'
import { Role } from '@types'

const App: React.FC = () => {
  const theme = createMuiTheme(
    {
      palette: {
        primary: {
          main: '#ff6900',
          contrastText: '#fff'
        },
        secondary: {
          main: orange[100]
        },
        success: {
          main: green[600]
        },
        warning: {
          main: red['A700']
        }
      }
    },
    esES
  )
  return (
    <>
      <Provider store={store}>
        <SnackbarProvider>
          <ThemeProvider theme={theme}>
            <ConnectedRouter history={history}>
              <PersistGate persistor={persistor}>
                <Layout>
                  <Switch>
                    <PrivateRoute exact path="/">
                      <HomeView />
                    </PrivateRoute>
                    <PrivateRoute exact path="/signup/:role">
                      <SignupView />
                    </PrivateRoute>
                    <PrivateRoute exact path="/club" blockedRoles={[Role.agente]}>
                      <ClubView />
                    </PrivateRoute>
                    <PrivateRoute exact path="/track">
                      <TrackingView />
                    </PrivateRoute>
                    <PrivateRoute exact path="/analyst-track">
                      <AnalystTrackView />
                    </PrivateRoute>
                    <PrivateRoute exact path="/analyst-rejected">
                      <AnalystRejectedView />
                    </PrivateRoute>
                    <PrivateRoute exact path="/analyst-review">
                      <AnalystCasesView />
                    </PrivateRoute>
                    <PrivateRoute exact path="/commissions-referrals" blockedRoles={[Role.agente]}>
                      <CommissionsReferrals />
                    </PrivateRoute>
                    <PrivateRoute exact path="/commissions">
                      <CommissionsView />
                    </PrivateRoute>
                    <PrivateRoute exact path="/cases">
                      <ExecutiveCasesView />
                    </PrivateRoute>
                    <PrivateRoute exact path="/track-filter">
                      <FilterTrack />
                    </PrivateRoute>
                    <PrivateRoute exact path="/profile">
                      <ProfileView />
                    </PrivateRoute>
                    <PrivateRoute exact path="/referrals">
                      <ReferralsView />
                    </PrivateRoute>
                    <PrivateRoute exact path="/resources">
                      <Resources />
                    </PrivateRoute>
                    <PrivateRoute exact path="/referrals">
                      <ReferralsView />
                    </PrivateRoute>
                    <PrivateRoute exact path="/prepayments" blockedRoles={[Role.agente]}>
                      <PrepaymentsView />
                    </PrivateRoute>
                    <PrivateRoute exact path="/manage" blockedRoles={[Role.agente]}>
                      <ManageView />
                    </PrivateRoute>
                    <PrivateRoute exact path="/configurations">
                      <Configurations />
                    </PrivateRoute>
                    <PrivateRoute exact path="/registro-horas">
                      <TimeTrackerView />
                    </PrivateRoute>
                    <PrivateRoute exact path="/metricas">
                      <AdminMetricsView />
                    </PrivateRoute>
                    <PrivateRoute exact path="/executive-commissions">
                      <ExecutiveCommissionsView />
                    </PrivateRoute>
                    <PrivateRoute exact path="/agent-commissions">
                      <AgentCommissionsView />
                    </PrivateRoute>
                    <PrivateRoute exact path="/agent-metrics" blockedRoles={AGENT_METRICS_BLOCKED_ROLES}>
                      <AgentMetricsView />
                    </PrivateRoute>
                    <PrivateRoute exact path="/executive-metrics" blockedRoles={EXECUTIVE_METRICS_BLOCKED_ROLES}>
                      <ExecutiveMetricsView />
                    </PrivateRoute>
                    <Route component={LoginView} path="/login" />
                    <Route exact component={PasswordRecoveryRequestView} path="/password-recovery" />
                    <Route component={PasswordRecoveryCompleteView} path="/password-recovery/reset" />
                  </Switch>
                </Layout>
              </PersistGate>
            </ConnectedRouter>
          </ThemeProvider>
        </SnackbarProvider>
      </Provider>
    </>
  )
}
export default App
